import React from 'react';

const Test: React.FC = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Test Page</h1>
      <p>This is a test page to verify that routing is working correctly.</p>
      <div style={{ marginTop: '2rem' }}>
        <h2>Available Routes</h2>
        <ul>
          <li><strong>/sign-in</strong> - Sign in page</li>
          <li><strong>/forgot-password</strong> - Forgot password page</li>
          <li><strong>/reset-password</strong> - Reset password page</li>
          <li><strong>/xml-creator</strong> - XML Creator (protected)</li>
          <li><strong>/xml-viewer</strong> - XML Viewer (protected)</li>
          <li><strong>/settings</strong> - Settings (protected, admin only)</li>
          <li><strong>/settings/users</strong> - User Management (protected, admin only)</li>
          <li><strong>/settings/customers</strong> - Customer Management (protected, admin only)</li>
          <li><strong>/profile</strong> - User Profile (protected)</li>
        </ul>
      </div>
    </div>
  );
};

export default Test;
